export default class GatheringStation {
    id: number;
    gatheringStationId: number;
    areaNumber: number;
    gsNo: number;
    gsName: string;
    gsField: string;
    gsType: string;
}



// WEBPACK FOOTER //
// ./src/models/projectSettings/subCode/section_types/GatheringStation.ts